import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableComissionsView extends JetView {
    /**
     * Configures the datatable view for commissions.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting
        const cur_user = this.getParam('user', true); // Current user parameter

        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            id: 'datatable', // ID for the datatable
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'rating',
                    header: 'Acción', // Header for action column
                    width: 80,
                    height: 25,
                    template: function (obj) {
                        // Template for action column
                        return "<span class='webix_icon wxi-close edit'></span>";
                    },
                },
                {
                    id: 'ProductName',
                    header: _('Producto'), // Localized header for product name
                    width: 150,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'ComissionLevel1',
                    header: _('Comisión Nivel 1'), // Localized header for commission level 1
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'ComissionLevel2',
                    header: _('Comisión Nivel 2'), // Localized header for commission level 2
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'ComissionLevel3',
                    header: _('Comisión Nivel 3'), // Localized header for commission level 3
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'ComissionLevel4',
                    header: _('Comisión Nivel 4'), // Localized header for commission level 4
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'ComissionLevelBetShop',
                    header: _('Comisión BetShop'), // Localized header for BetShop commission
                    width: 150,
                    sort: 'int',
                },
            ],
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            // API endpoint for fetching commission data
            url: devConfig.geturlApi() + 'AgentList/GetCommission?FromId=' + cur_user + '&',
            data: [
                // Initial data for the datatable
                {
                    ProductName: 'Deposito',
                    ComissionLevel1: '3',
                    ComissionLevel2: '4',
                    ComissionLevel3: '5',
                    ComissionLevel4: '6',
                    ComissionLevelBetShop: '7',
                },
            ],
            onClick: {
                // Event handler for click events
                edit: function (euv, id) {
                    // Edit action
                    $$('editWinComAgent').show(); // Show edit window
                },
            },
        };
    }

    /**
     * Initializes the datatable and binds events.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var initThis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = grid.data.url; // URL for data fetching
        var popup = webix.ui({
            // Popup window for editing commissions
            view: 'window',
            id: 'editWinComAgent',
            head: 'Editar Comisión', // Header for the popup
            position: 'center',
            modal: true, // Modal window
            body: {
                view: 'form', // Form inside the popup
                id: 'editformComAgent',
                elements: [
                    // Form elements
                    {
                        view: 'text',
                        label: _('Producto'), // Localized label for product
                        labelWidth: 150,
                        name: 'ProductName',
                        readonly: false,
                    },
                    {
                        view: 'text',
                        label: _('Comisión Nivel 1'), // Localized label for commission level 1
                        labelWidth: 150,
                        name: 'ComissionLevel1',
                        readonly: false,
                        type: 'number', // Input type
                    },
                    {
                        view: 'text',
                        label: _('Comisión Nivel 2'), // Localized label for commission level 2
                        labelWidth: 150,
                        name: 'ComissionLevel2',
                        readonly: false,
                        type: 'number',
                    },
                    {
                        view: 'text',
                        label: _('Comisión Nivel 3'), // Localized label for commission level 3
                        labelWidth: 150,
                        name: 'ComissionLevel3',
                        readonly: false,
                        type: 'number',
                    },
                    {
                        view: 'text',
                        label: _('Comisión Nivel 4'), // Localized label for commission level 4
                        labelWidth: 150,
                        name: 'ComissionLevel4',
                        readonly: false,
                        type: 'number',
                    },
                    {
                        view: 'text',
                        label: _('Comission BetShop'), // Localized label for BetShop commission
                        labelWidth: 150,
                        name: 'ComissionLevelBetShop',
                        readonly: false,
                        type: 'number',
                    },
                    {
                        cols: [
                            // Button layout
                            {
                                view: 'button',
                                value: _('Cancelar'), // Localized button label for cancel
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Localized button label for save
                                click: function ($e) {
                                    var values = $$('editformComAgent').getValues(); // Get form values
                                    const user = initThis.getParam('user', true); // Get current user
                                    webix // AJAX request to update commission
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'AgentList/UpdateCommission',
                                            '{"FromId":' +
                                                user +
                                                ',"ProductName":' +
                                                values.ProductName +
                                                ',"ComissionLevel1":"' +
                                                values.ComissionLevel1 +
                                                '","ComissionLevel2":"' +
                                                values.ComissionLevel2 +
                                                ',"ComissionLevel3":"' +
                                                values.ComissionLevel3 +
                                                ',"ComissionLevel4":"' +
                                                values.ComissionLevel4 +
                                                ',"ComissionLevelBetShop":"' +
                                                values.ComissionLevelBetShop +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Valores Editados')); // Show success message
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(url); // Reload the grid data
                                                },
                                            },
                                        );
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                        ],
                    },
                ],
            },
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Double-click event to show popup
            popup.show(); // Show the edit popup
        });
        $$('editformComAgent').bind($$('datatable')); // Bind form to datatable
    }
}

// FILE DOCUMENTED
